<template>
    <v-container>
        <template>
            <v-row justify="center">
                <v-dialog
                    v-model="deleteDialog"
                    persistent
                    max-width="290"
                >
                    <v-card>
                        <v-card-text class="headline">
                            Are you sure you want to delete this record ?
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                                color="accent"
                                @click="deleteDialog = false"
                            >
                                Cancel
                            </v-btn>
                            <v-btn
                                color="info"
                                :loading="deleting"
                                @click="deleteAnalysisRecord()"                                              
                            >
                                Confirm
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-row>
        </template>
        <template>
            <v-row justify="center" max-width="60%">
                <v-dialog v-model="editDialog" v-if="editDialog">
                    <v-card background-color="white">
                        <v-toolbar
                            dark
                            color="primary"
                        >
                            <v-btn
                                icon
                                dark
                                @click="editDialog = false"
                            >
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                            <v-toolbar-title>Edit</v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                        <EditVenomAnalysis :editRecord="editRecord" @closeEditDialog="closeEditDialog" @update="updateAnalysis"> </EditVenomAnalysis>
                    </v-card>
                </v-dialog>
            </v-row>
        </template>
        <template>
            <v-row>
                <v-dialog v-model="previewPDFDialog" v-if="previewPDFDialog" fullscreen>
                    <v-card>
                        <v-toolbar
                            dark
                            color="primary"
                        >
                            <v-btn
                                icon
                                dark
                                @click="previewPDFDialog = false"
                            >
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                            <v-toolbar-title>Preview</v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                        <PreviewPDF :filePath="previewFilePath" :loading="previewing" :isPDF="isPDF"> </PreviewPDF>
                    </v-card>
                </v-dialog>
            </v-row>
        </template>
        <v-progress-linear indeterminate v-if="loading"></v-progress-linear>
        <v-data-table v-else
            :items="records"
            :items-per-page="20"
            :footer-props="{ 'items-per-page-options': [10,20,50,-1] }"
            :headers="mainHeaders"
            show-expand
            :expanded.sync="expanded"
            item-key="VenomAnalysisID"
            sort-by="AnalysisDate"
            :sort-desc="true">
            <template v-slot:item.AnalysisDate="{ item }">
                {{ $moment.utc(item.AnalysisDate).format($constants.DATE_FORMAT_NO_TIME) }}
            </template>
        
            <template v-slot:item.Download="{ item }">
                <v-btn
                    v-if="item.S3Path"
                    color="info"
                    :loading="downloading"
                    :disabled="downloading"
                    @click="download(item.S3Path)">Download</v-btn>
            </template>
            <template v-slot:item.Preview="{ item }">
                <v-btn
                    v-if="item.S3Path"
                    color="info"
                    @click="preview(item.S3Path)">Preview</v-btn>
            </template>
            <template v-slot:item.Edit="{ item }">
                <v-btn
                    v-if="permission"
                    color="orange"
                    :loading="editing"
                    :disabled="editing"
                    @click="showEditDialog(item)">Edit</v-btn>
            </template>
            <template v-slot:item.Delete="{ item }">
                <v-btn
                    v-if="permission"
                    color="accent"
                    :loading="deleting"
                    :disabled="deleting"
                    @click="showDeleteDialog(item)">Delete</v-btn>
            </template>
            <template v-slot:expanded-item="{ headers , item }" >
                <td :colspan="headers .length" class="expansion-panel">
                    <v-simple-table v-if="item.Proteins.length > 0">
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="text-left">
                                        Name
                                    </th>
                                    <th class="text-left">
                                        Low Area %
                                    </th>
                                    <th class="text-left">
                                        High Area %
                                    </th>
                                    <th class="text-left">
                                        Comments
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="pro in item.Proteins"
                                    :key="pro.VenomAnalysisProteinID"
                                >
                                    <td>{{ pro.Name }}</td>
                                    <td>{{ pro.LowRange.toFixed(2) }}</td>
                                    <td>{{ pro.HighRange.toFixed(2) }}</td>
                                    <td>{{ pro.Comments }}</td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                    <v-alert type="warning" text class="mt-5" v-else>There were no proteins entered in the analysis</v-alert>
                </td>
            </template>
        </v-data-table>
    </v-container>
</template>

<script>
import * as venomAnalysisAPI from '@/services/venomAnalysisAPI';
import fileService from "../../services/fileService";
import EditVenomAnalysis from "./EditVenomAnalysis";
import PreviewPDF from "./PreviewPDF"

export default {

     components: {
        EditVenomAnalysis,
        PreviewPDF
    },
    props: {
        specimenID: {
            type: Number,
            default: -1
        },
        dailyExtractionID: {
            type: Number,
            default: -1
        },
        monthlyPoolID: {
            type: Number,
            default: -1
        },
        venomLotID: {
            type: Number,
            default: -1
        },
        speciesBatchPoolID: {
            type: Number,
            default: -1
        }
    },
    data() {
        return {
            loading: false,
            downloading: false,
            previewing:false,
            previewPDFDialog:false,
            previewFilePath:"",
            isPDF:true,
            records: [],
            expanded: [],
            loadingError: "",
            deleteDialog:false,
            deleteItem:null,
            deleting:false,

            editRecord:null,
            editDialog:false,
            editing:false,

            mainHeaders: [
                {
                    text: "Analysis Date",
                    value: "AnalysisDate"
                },
                {
                    text: "Other Comments",
                    value: "OtherComments"
                },
                {
                    text: "",
                    value: "Download",
                    class: "min-width-column"
                },
                {
                    text: "",
                    value: "Preview",
                    class: "min-width-column"
                },
                {
                    text: "",
                    value: "Delete",
                    class: "min-width-column"
                },
                {
                    text: "",
                    value: "Edit",
                    class: "min-width-column"
                },
                { 
                    text: '', 
                    value: 'data-table-expand' 
                }
            ]
        };
    },
    computed:{
        permission:function(){
            return this.$store.state.authStore.user.UserProfile.Permissions.admin;
        }
    },
    methods: {
        async download(s3Path) {
            this.downloading = true;

            var filePath = await fileService.getDownloadURL(s3Path);

            this.downloading = false;
            if (filePath && filePath != ""){
                window.open(filePath, '_blank');
            }
        },
        async preview(s3Path) {

            this.previewPDFDialog = true;
            if(!(s3Path.toLowerCase().includes("pdf"))){
                this.previewFilePath = "";
                return this.isPDF = false;
            }
            else{

                this.isPDF = true;
                this.previewing = true;

                var filePath = await fileService.getDownloadURL(s3Path);

                this.previewing = false;
                this.previewFilePath = filePath; 
            }
                   
        },
        async loadAnalysis() {
            this.loading = true;
            this.loadingError = "";

            try {
                this.records = await venomAnalysisAPI.getHistoricalAnalysis(this.specimenID, this.dailyExtractionID, this.monthlyPoolID, this.venomLotID, this.speciesBatchPoolID);
                this.expanded = [ this.records[0] ]
            } catch (e) {
                this.loadingError = e.message
            }

            this.loading = false;
        },
        async deleteAnalysisRecord(){
            this.deleting = true;
            try {
                await venomAnalysisAPI.deleteVenomAnalysis(this.deleteItem);
                //delete file
                if(this.deleteItem.S3Path != null){
                  
                    await fileService.deleteFileAndDocument(this.deleteItem.S3Path,this.deleteItem.VenomAnalysisID);
                }
                this.expanded = [ this.records[0] ]
            } 
            catch (e) {
                this.loadingError = e.message
            }
            this.deleteDialog = false;
            this.deleting = false;
            this.loadAnalysis();

        },
        async updateAnalysis(){
            await this.loadAnalysis();
        },
        showDeleteDialog(item){

            this.deleteItem = item;
            this.deleteDialog = true;
     },
        showEditDialog(item){

        this.editRecord = item;
        this.editDialog = true;
    },

        closeEditDialog(){
            this.editDialog = false;
        }
},

async created() {
        await this.loadAnalysis();
},

}
</script>

<style>
    .min-width-column {
        width: 1%;
    }
</style>

<style scoped>
    .expansion-panel {
        background-color: white;
    }
</style>